import { boot } from 'quasar/wrappers'
import { setCommonDefaults } from 'src/componentDefaults'
import QItemStandalone from '@wilken8/portal-ui-common/components/overrides/QItemStandalone.js'

export default boot(({ app }) => {
  app.component(QItemStandalone.name, QItemStandalone)
  // common component defaults
  setCommonDefaults()
})
